window.addEventListener("load", () => {
  const triggers = document.querySelectorAll(".award-accordion-trigger");
  triggers.forEach((trigger) => {
    trigger.addEventListener("click", () => {
      const targetId = trigger.getAttribute("data-target");
      const content = document.getElementById(targetId);
      const icon = trigger.querySelector(".award-accordion-icon");
      const isOpening = content.classList.contains("hidden");
      const getClasses = (type) => {
        const bg = trigger.dataset[`${type}Bg`];
        const txt = trigger.dataset[`${type}Text`];
        const borders = trigger.dataset[`${type}Border`].split(" ");
        return [bg, txt, ...borders];
      };
      const openClasses = getClasses("open");
      const closedClasses = getClasses("closed");
      content.classList.toggle("hidden");
      if (isOpening) {
        trigger.classList.remove(...closedClasses);
        trigger.classList.add(...openClasses);
        icon.src = icon.dataset.openSrc;
      } else {
        trigger.classList.remove(...openClasses);
        trigger.classList.add(...closedClasses);
        icon.src = icon.dataset.closedSrc;
      }
    });
  });

  const videoPlaceholders = document.querySelectorAll(".video-placeholder");

  videoPlaceholders.forEach((placeholder) => {
    placeholder.addEventListener("click", () => {
      const container = placeholder.closest(".video-container");
      const target = container.querySelector(".video-player-target");
      const template = container.querySelector(".video-embed-code");

      if (!template) return;

      let embedHtml = template.innerHTML;
      if (embedHtml.includes("youtube.com")) {
        embedHtml = embedHtml.replace(
          "feature=oembed",
          "feature=oembed&autoplay=1",
        );
      } else if (embedHtml.includes("vimeo.com")) {
        embedHtml = embedHtml.replace("?", "?autoplay=1&");
      }

      target.innerHTML = embedHtml;
      const iframe = target.querySelector("iframe");
      if (iframe) {
        iframe.classList.add("w-full", "h-full", "absolute", "inset-0");
      }

      placeholder.classList.add("hidden");
      target.classList.remove("hidden");
    });
  });
});
